import { useState } from 'react';
import { Link } from 'react-router';

/**
 * Marketing site navigation bar
 * - Dark theme: near-black with backdrop blur
 * - Minimal nav: How It Works, About
 * - Login as subtle text link
 * - "Early Access" CTA with gold accent
 * - Mobile hamburger menu
 * - Logo in warm off-white Georgia serif (placeholder for GT Sectra)
 */
export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { label: 'How It Works', to: '/how-it-works' },
    { label: 'About', to: '/about' },
  ];

  return (
    <nav
      className="sticky top-0 z-50 border-b backdrop-blur-md"
      style={{
        backgroundColor: 'rgba(12,12,12,0.80)',
        borderColor: 'rgba(255,255,255,0.06)',
      }}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">

          {/* Logo */}
          <div className="flex-shrink-0">
            <Link
              to="/"
              className="text-xl tracking-tight transition-opacity hover:opacity-80"
              style={{ color: '#f0ece4', fontFamily: 'Georgia, serif' }}
            >
              Jerico
            </Link>
          </div>

          {/* Desktop nav links */}
          <div className="hidden md:flex md:items-center md:gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm transition-colors hover:text-[#f0ece4]"
                style={{ color: '#a8a29e' }}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop right-side actions */}
          <div className="hidden md:flex md:items-center md:gap-6">
            <Link
              to="/login"
              className="text-sm transition-colors hover:text-[#f0ece4]"
              style={{ color: '#78716c' }}
            >
              Login
            </Link>
            <Link
              to="/early-access"
              className="rounded px-4 py-2 text-sm font-medium tracking-wide transition-opacity hover:opacity-90"
              style={{ backgroundColor: '#c9a96e', color: '#0c0c0c' }}
            >
              Early Access
            </Link>
          </div>

          {/* Mobile hamburger */}
          <div className="flex md:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="inline-flex items-center justify-center rounded p-2 transition-colors hover:text-[#f0ece4]"
              style={{ color: '#a8a29e' }}
              aria-expanded={mobileMenuOpen}
              aria-label="Toggle menu"
            >
              <svg
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div
          className="border-t md:hidden"
          style={{ borderColor: 'rgba(255,255,255,0.06)' }}
        >
          <div className="space-y-1 px-4 pb-4 pt-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="block rounded px-3 py-2.5 text-sm transition-colors hover:text-[#f0ece4] hover:bg-white/[0.04]"
                style={{ color: '#a8a29e' }}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3 border-t" style={{ borderColor: 'rgba(255,255,255,0.06)' }}>
              <Link
                to="/login"
                className="block rounded px-3 py-2.5 text-sm transition-colors hover:text-[#f0ece4] hover:bg-white/[0.04]"
                style={{ color: '#78716c' }}
                onClick={() => setMobileMenuOpen(false)}
              >
                Login
              </Link>
              <Link
                to="/early-access"
                className="mt-2 block rounded px-3 py-2.5 text-sm font-medium text-center tracking-wide transition-opacity hover:opacity-90"
                style={{ backgroundColor: '#c9a96e', color: '#0c0c0c' }}
                onClick={() => setMobileMenuOpen(false)}
              >
                Early Access
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
